module.exports = __webpack_public_path__ + "static/media/202409tuanjian.c209d897.jpg";